import { DriveStep } from 'driver.js';
import type { TFunction } from 'i18next';

export const createPreparationTourSteps = (
  t: TFunction,
  currentStep: number,
): DriveStep[] => {
  const steps: DriveStep[] = [];

  // Step 1 — Goal (step === 1)
  if (currentStep === 1) {
    steps.push({
      element: '[data-tour="prep-goal-grid"]',
      popover: {
        title: t('onboarding.prep.goal_title', 'Тип выступления'),
        description: t(
          'onboarding.prep.goal_desc',
          'Выберите формат: конференция, питч, воркшоп и т.д. Стиль речи подбирается под цель.',
        ),
      },
    });
  }

  // Step 2 — Audience (step === 2)
  if (currentStep === 2) {
    steps.push({
      element: '[data-tour="prep-audience"]',
      popover: {
        title: t('onboarding.prep.audience_title', 'Аудитория'),
        description: t(
          'onboarding.prep.audience_desc',
          'Укажите тип и размер аудитории. ИИ адаптирует глубину текста.',
        ),
      },
    });

    steps.push({
      element: '[data-tour="prep-audience-size"]',
      popover: {
        title: t('onboarding.prep.audience_size_title', 'Количество аудитории'),
        description: t(
          'onboarding.prep.audience_size_desc',
          'Введите примерное количество слушателей для калибровки темпа и глубины речи.',
        ),
      },
    });
  }

  // Step 3 — Duration (step === 3)
  if (currentStep === 3) {
    steps.push({
      element: '[data-tour="prep-duration"]',
      popover: {
        title: t('onboarding.prep.duration_title', 'Длительность'),
        description: t(
          'onboarding.prep.duration_desc',
          'Укажите планируемое время выступления — текст будет подогнан под тайминг.',
        ),
      },
    });
  }

  // Step 4 — Upload (step === 4)
  if (currentStep === 4) {
    steps.push({
      element: '[data-tour="prep-upload"]',
      popover: {
        title: t('onboarding.prep.upload_title', 'Загрузка PDF'),
        description: t(
          'onboarding.prep.upload_desc',
          'Загрузите PDF-презентацию. Мы извлечём текст и изображения слайдов.',
        ),
      },
    });
  }

  // Step 5 — Review (step === 5)
  if (currentStep === 5) {
    steps.push({
      element: '[data-tour="prep-review"]',
      popover: {
        title: t('onboarding.prep.review_title', 'Проверка данных'),
        description: t(
          'onboarding.prep.review_desc',
          'Проверьте все параметры и нажмите «Отправить». Анализ займёт несколько минут.',
        ),
      },
    });
  }

  return steps;
};
